function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Rectangle_343",
  x: 0,
  y: 18.262,
  width: 63.996,
  height: 40.473,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_86",
  x: 32.283,
  y: 0,
  width: 11.207,
  height: 11.207,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "blur-2"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_461",
  "data-name": "Group 461",
  transform: "translate(6672.022 21000.82) rotate(11)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_341",
  "data-name": "Rectangle 341",
  transform: "matrix(0.695, 0.719, -0.719, 0.695, -10519.834, -19343.18)",
  fill: "#fff",
  stroke: "#9a9a9a",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 28,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  height: 26.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_342",
  "data-name": "Rectangle 342",
  transform: "translate(-10519.57 -19342.342) rotate(-39)",
  fill: "#fff",
  stroke: "#9a9a9a",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 26.066,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  height: 24.566,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_460",
  "data-name": "Group 460",
  transform: "translate(327.818 -192.391) rotate(-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.98, -0.17, 0.17, 0.98, -10548.54, -19336.54)",
  filter: "url(#Rectangle_343)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_343-2",
  "data-name": "Rectangle 343",
  transform: "matrix(0.98, 0.17, -0.17, 0.98, 5.36, 18.76)",
  fill: "#fff",
  stroke: "#9a9a9a",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 57,
  height: 28,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 55.5,
  height: 26.5,
  rx: 1.25,
  fill: "none"
}))), /*#__PURE__*/React.createElement("text", {
  id: "SOLD_OUT",
  "data-name": "SOLD OUT",
  transform: "translate(-10535 -19301)",
  fill: "#e61236",
  fontSize: 10,
  fontFamily: "DIN-Medium, DIN",
  fontWeight: 500,
  opacity: 0.75
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "SOLD OUT"))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.98, -0.19, 0.19, 0.98, -10556.58, -19341.89)",
  filter: "url(#Ellipse_86)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_86-2",
  "data-name": "Ellipse 86",
  transform: "translate(34.12 0.5) rotate(11)",
  fill: "#fff",
  stroke: "#9a9a9a",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 3.5,
  r: 2.75,
  fill: "none"
}))));

var SvgBedges3 = function SvgBedges3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.996,
    height: 58.732,
    viewBox: "0 0 63.996 58.732",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBedges3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bedges3.5ff4f243.svg";
export { ForwardRef as ReactComponent };